import { useEffect, useState } from 'react'
import { avvisiAttivi, type Avviso } from './avvisi.api'

export function Avvisi() {
  const [avvisi, setAvvisi] = useState<Avviso[]>([])

  useEffect(() => {
    avvisiAttivi()
      .then(setAvvisi)
      .catch(() => setAvvisi([]))
  }, [])

  if (avvisi.length === 0) return null

  return (
    <div className="avvisi">
      {avvisi.map((a) => (
        <aside key={a.id} className={`avviso avviso-${a.tipo}`} role="status">
          <strong>{a.titolo}</strong>
          <p>{a.corpo}</p>
        </aside>
      ))}
    </div>
  )
}
